import { Button, InputPhoneNumber } from "@sellar-io/components";
import { useForm, useWatch } from "react-hook-form";
import { InputContainer } from "@sellar-io/components";

type CheckoutEditPhoneNumberFormProps = {
  onConfirm: (data: string) => void;
  initialData: string;
};

type PhoneNumber = { phoneNumber: string };

export const CheckoutEditPhoneNumberForm = ({
  initialData,
  onConfirm,
}: CheckoutEditPhoneNumberFormProps) => {
  const { handleSubmit, setValue, control } = useForm<PhoneNumber>({
    defaultValues: { phoneNumber: initialData },
    shouldUseNativeValidation: true,
  });
  const phoneNumber = useWatch({
    control,
    name: "phoneNumber",
  });

  const handleUserSubmit = (data: PhoneNumber) => {
    onConfirm(data.phoneNumber);
  };

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={handleSubmit(handleUserSubmit)}
    >
      <InputContainer>
        <InputPhoneNumber
          value={phoneNumber}
          onChange={(phoneNumber) =>
            setValue("phoneNumber", phoneNumber, { shouldValidate: true })
          }
          placeholder="+44 7123456789"
          inputProps={{ required: true, name: "phoneNumber" }}
        />
      </InputContainer>

      <Button type="submit" className="w-full">
        Update
      </Button>
    </form>
  );
};
